window.PubSub = window.PubSub || {
  subscribers: {},

  subscribe(eventName, callback) {
    if (!this.subscribers[eventName]) {
      this.subscribers[eventName] = [];
    }

    this.subscribers[eventName] = [...this.subscribers[eventName], callback];

    return () => {
      this.subscribers[eventName] = this.subscribers[eventName].filter((cb) => cb !== callback);
    };
  },

  publish(eventName, data) {
    if (!this.subscribers[eventName]) return;

    this.subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  },
};